import Text from '@cartwhl/ui/base/Text';
import CameraIconAlternative from '@cartwhl/ui/icons/CameraIconAlternative';
import ImagePlaceholderIcon from '@cartwhl/ui/icons/ImagePlaceholderIcon';
import Button from '@cartwhl/ui/input/Button';

import { ImageFilePicker } from 'components/ImageUploadModal';
import { navigationStore } from 'stores';

export default function ImageToPose() {
  return (
    <div className="relative h-[154px] rounded-2xl bg-white/80">
      <ImageFilePicker>
        {/* Purposefully send an empty child so that ImageFilePicker doesn't render a picker */}
        <span />
      </ImageFilePicker>

      <div className="text-gray-90 pointer-events-none absolute inset-0 flex h-full flex-col items-center justify-center gap-2">
        <div className="flex items-center gap-1.5">
          <ImagePlaceholderIcon className="text-blue" />
          <Text variant="studio/body/medium/sm">
            <span className="text-blue">Select File</span>{' '}
            <span className="hidden md:inline">or drag and drop one here</span>
          </Text>
        </div>
        <Text
          variant="studio/body/medium/sm"
          className="text-gray-45 dark:text-gray-60"
        >
          or
        </Text>

        <Button
          variant="primary"
          size="sm"
          icon={<CameraIconAlternative />}
          className="pointer-events-auto"
          onClick={() =>
            navigationStore.setImageUploadModal({ mode: 'media capture' })
          }
        >
          Capture new image
        </Button>
      </div>
    </div>
  );
}
